import Vue from "vue";

export const TOAST_RESULT = {
  KO: "KO",
  OK: "OK",
  WARN: "WARN",
};

const TOAST_DEAFULT_SETTINGS = {
  duration: 4000,
  position: "bottom-right",
  theme: "toasted-primary",
};

export const makeToast = (result, message) => {
  switch (result) {
    case TOAST_RESULT.OK:
      Vue.toasted.show(message, {
        name: "toast-success",
        type: "success",
        ...TOAST_DEAFULT_SETTINGS,
        icon: {
          name: "check",
        },
      });
      break;
    case TOAST_RESULT.KO:
      Vue.toasted.show(message, {
        name: "toast-error",
        type: "error",
        ...TOAST_DEAFULT_SETTINGS,
        icon: {
          name: "exclamation",
        },
      });
      break;
    case TOAST_RESULT.WARN:
      Vue.toasted.show(message, {
        name: "toast-warn",
        type: "info",
        ...TOAST_DEAFULT_SETTINGS,
        duration: 6000,
        className: ["SisrWarningToast"],
        icon: {
          name: "exclamation-triangle",
        },
      });
      break;
    default:
      throw new Error();
  }
};
